<template>
  <div class="modal__content">
    <slot v-bind="{ close }" />
  </div>
</template>

<script setup lang="ts">
const $modal = inject('$modal', {
  close: (...args: any) => args
});

const close = (...args: any) => $modal.close(...args);
</script>

<style lang="postcss">
.modal__content {
  /* Scale with the viewport (header + footer + frame padding ≈ 14rem) instead of a fixed 484px */
  @apply max-h-[max(484px,calc(100dvh-14rem))] overflow-y-auto bg-white p-8;
}
</style>
